module.exports = __webpack_public_path__ + "media/images/kyoto_banner_pc-6c64ccd2bc3219874374046c8ea52944.jpg";